/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sold: NonNullable<unknown>, total: NonNullable<unknown> }} Ticketssoldof2Inputs */

const en_ticketssoldof2 = /** @type {(inputs: Ticketssoldof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sold} of ${i?.total} sold`)
};

const de_ticketssoldof2 = /** @type {(inputs: Ticketssoldof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sold} von ${i?.total} verkauft`)
};

/**
* | output |
* | --- |
* | "{sold} of {total} sold" |
*
* @param {Ticketssoldof2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketssoldof2 = /** @type {((inputs: Ticketssoldof2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketssoldof2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketssoldof2(inputs)
	return de_ticketssoldof2(inputs)
});
export { ticketssoldof2 as "ticketsSoldOf" }